import React, { useRef } from "react";
import { makeStyles } from "tss-react/mui";
import { MemoizedChip } from "../chip/ChipRenderer.js";
import "../chip/Chips.js";
import "../chip/ListWithChipTooltip.js";
import "../chip/SquaredChipList.js";
import "@mui/material";
import "../icons/Icon.js";
import "../icons/ExpandMoreIcon.js";
import "../button/Buttons.js";
import "../button/EditButton.js";
import { DropdownType } from "../dropdown/DropdownHoc.js";
import { DropdownWithChip } from "../dropdown/DropdownWithChip.js";
import { DropdownItem } from "../dropdown/DropdownItem.js";
import "./EditProvider.js";
import { withEditButton } from "./EditButtonHoc.js";
import "./EditableText.js";
import "uuid";
import "./EditableAutocomplete.js";
import { LocalizedText } from "../i18n/LocalizedText.js";
import { dashCharacter } from "../label/EmptyLabel.js";
import "../label/LabelHoc.js";
const useClasses = makeStyles()((theme) => ({
  editableSelect: {
    width: "100%",
    display: "flex",
    marginLeft: "auto",
    position: "relative",
    overflow: "visible !important",
    padding: "0 !important"
  },
  editableSelectButton: {
    width: "100%",
    height: "32px",
    padding: theme.spacing(1, 1.5),
    justifyContent: "space-between"
  },
  editableSelectButtonOpen: {
    border: `1px solid ${theme.custom.palette.content.border}`,
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0
  },
  editableSelectContainer: {
    minWidth: "unset"
  }
}));
const EditableSelectInternal = ({ mode, chipType, className, ...props }) => {
  const { cx, classes } = useClasses();
  const containerRef = useRef(null);
  const { disabled, value, options } = props;
  const isEditDisabled = disabled || mode !== "Edit";
  const selectedOption = options.find((i) => i.value === value);
  const selectedLabel = selectedOption?.label || dashCharacter;
  function getValueInReadMode() {
    const isEmpty = !value;
    const isChip = chipType !== void 0;
    let res = /* @__PURE__ */ React.createElement(React.Fragment, null);
    if (isEmpty) {
      res = /* @__PURE__ */ React.createElement(React.Fragment, null, dashCharacter);
    } else if (isChip) {
      res = /* @__PURE__ */ React.createElement(MemoizedChip, { chipName: chipType, value, cursorPointer: true });
    } else {
      res = /* @__PURE__ */ React.createElement(LocalizedText, { label: selectedLabel ?? dashCharacter });
    }
    return res;
  }
  return /* @__PURE__ */ React.createElement("div", { className: cx(classes.editableSelect, className), ref: containerRef }, isEditDisabled ? getValueInReadMode() : /* @__PURE__ */ React.createElement(
    DropdownWithChip,
    {
      styles: {
        dropdownContainer: classes.editableSelectContainer,
        dropdownButton: classes.editableSelectButton,
        dropdownButtonOpen: classes.editableSelectButtonOpen
      },
      selectedText: selectedLabel ?? dashCharacter,
      container: containerRef.current,
      dropdownType: DropdownType.Attached,
      closeOnClickInside: true
    },
    options.map((option, index) => /* @__PURE__ */ React.createElement(
      DropdownItem,
      {
        key: index,
        onClick: () => {
          const submitValue = option.value;
          return props.onSubmit(submitValue);
        },
        confirmIcon: true,
        label: option.label,
        selected: value === option.value,
        disabled: option.disabled
      }
    ))
  ));
};
const EditableSelect = withEditButton(EditableSelectInternal);
export {
  EditableSelect,
  EditableSelectInternal
};
//# sourceMappingURL=EditableSelect.js.map
